import { connect } from 'react-redux';
import View from './AssetAllocationView';
import { goalId as selectedGoalId } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import RouteDictionary from '../WhatIfsRouteDictionary';
import {
  preChartDataSelector,
  preLegendSelector,
  modelPortfoliosOptionsSelector,
  modelPortfolioGroupsSelector,
  preRetirementPortfolioIdSelector,
} from './AssetAllocationSelector';
import {
  updateWhatIfsData,
  applyWhatIf,
  fetchWhatIfOptions,
  planImpact,
  initialPlanImpact,
  setDetailedAssetAllocationOpen,
} from '../WhatIfsActions';
import {
  loading,
  nullableFpIdSelector,
  areOptionsLoaded,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
  impactSelector,
  nullableTitleSelector,
  nullableGroupTitleSelector,
  isOPLMonteCarloSelector,
} from '../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  loading: loading(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  planImpactItems: impactSelector(state, ownProps),
  chartData: preChartDataSelector(state, ownProps),
  modelPortfoliosOptions: modelPortfoliosOptionsSelector(state, ownProps),
  legend: preLegendSelector(state, ownProps),
  apiPortfolioNameKey: 'PreRetirementPortfolioName',
  apiPortfolioIdKey: 'PreRetirementPortfolioId',
  modelPortfolioGroups: modelPortfolioGroupsSelector(state),
  portfolioId: preRetirementPortfolioIdSelector(state, ownProps),
  isOPLMonteCarlo: isOPLMonteCarloSelector(state),
});

const mapDispatchToProps = dispatch => ({
  detailedAssetAllocationClicked: clientId => () => {
    dispatch(setDetailedAssetAllocationOpen(clientId, true));
  },
  storeData: (goalId, whatIfType, data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatIfType, data));
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      planImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      initialPlanImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  fetchData: (clientId, fpId, goalId, whatIfType) => {
    dispatch(fetchWhatIfOptions(clientId, fpId, goalId, RouteDictionary[whatIfType], whatIfType));
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate) => () => {
    dispatch(
      applyWhatIf(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
